module.exports = __webpack_public_path__ + "media/CONFIRM.0b8e44b0.mp3";